import React, { Component } from "react";
import Map from "./map";
import { PortionsContext } from "../context/PortionsContext";
import close from "../assets/images/interface/close.svg";
import PortionSelector from "./PortionSelector";
import PropTypes from "prop-types";

class MapContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        {
          this.context.showPortionsList &&
          <div className="home-filters desktop-noDisplay" >
            <div className="home-filters-header desktop-noDisplay">
              <span className="home-filters-header-title">Lista de loteamientos</span>
              <button className="home-filters-header-close" onClick={this.context.togglePortionsList}>
                <img className="" src={close} alt="X" ></img>
              </button>
            </div>
            <div className="home-filters-body">
              <div className="portions-container">
                <PortionSelector history={this.props.history} navigation={this.props.navigation} />
              </div>
            </div>
          </div>
        }


        {this.props.children}
      </>
    );
  }
}

MapContainer.contextType = PortionsContext;

MapContainer.defaultProps = {
  largeMode: false,
  showInfo: false,
  navigation: true,
}

MapContainer.propTypes = {
  action: PropTypes.string.isRequired,
  mapHeight: PropTypes.string.isRequired,
  largeMode: PropTypes.bool,
  navigation: PropTypes.bool,
}

export default MapContainer;
